module.exports = __webpack_public_path__ + "img/云天化集团.2e892c68.png";